import { EventAttributeFiltersContent, FilterScopeProvider } from '@statsbomb/kitbag-global-football';
import { useKgfEventAttributeProps } from '@/hooks/useKgfEventAttributeProps';

export const EventAttributeFilters = () => {
  const { outcomeOptions, eventNameOptions, eventNameOptionsLoading } = useKgfEventAttributeProps();
  return (
    <FilterScopeProvider scope="main">
      <EventAttributeFiltersContent
        outcomeOptions={outcomeOptions}
        eventOptions={eventNameOptions}
        eventOptionsLoading={eventNameOptionsLoading}
      />
    </FilterScopeProvider>
  );
};
